import { createSlice } from "@reduxjs/toolkit";
import {
    createSellerBannerThunk,
    deleteSellerBannerThunk,
    fetchSellerBannersThunk,
    updateSellerBannerThunk
} from "./sellerBannersThunk";

const sellerBannersSlice = createSlice({
    name: "seller-banners",
    initialState: {
        items: [],
        loading: false,
        error: null
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchSellerBannersThunk.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchSellerBannersThunk.fulfilled, (state, action) => {
                state.loading = false;
                state.items = action.payload;
            })
            .addCase(fetchSellerBannersThunk.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })

            .addCase(createSellerBannerThunk.fulfilled, (state, action) => {
                const newBanner = action.payload;
                state.items = [newBanner, ...state.items];
            })

            .addCase(updateSellerBannerThunk.fulfilled, (state, action) => {
                const updatedBanner = action.payload;
                state.items = state.items.map((e) => {
                    if (e.id === updatedBanner.id) {
                        return updatedBanner;
                    } else {
                        return e;
                    }
                });
            })

            .addCase(deleteSellerBannerThunk.fulfilled, (state, action) => {
                const deletedBannerId = action.payload;
                state.items = state.items.filter((e) => e.id !== deletedBannerId);
            });
    }
});

export default sellerBannersSlice.reducer;
